import React, { useMemo } from 'react';
import { AdvancedFiltersContext } from './AdvancedFiltersContext';
import { AdvancedFiltersContextType } from './types';

interface AdvancedFiltersProviderProps extends AdvancedFiltersContextType {
  children?: React.ReactNode;
}

/**
 * A component that can be used to provide advancedFilters information to other components in the
 * component tree.
 */
export const AdvancedFiltersProvider = ({
  children,
  clear,
  value,
  updateFilterValue,
  prefix,
  drafts,
}: AdvancedFiltersProviderProps) => {
  const contextValue = useMemo<AdvancedFiltersContextType>(
    () => ({ clear, value, updateFilterValue, prefix, drafts }),
    [clear, value, updateFilterValue, prefix, drafts],
  );

  return (
    <AdvancedFiltersContext.Provider value={contextValue}>
      {children}
    </AdvancedFiltersContext.Provider>
  );
};
